var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "page-header" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-3",
              attrs: { variant: "link" },
              on: {
                click: function($event) {
                  return _vm.onBack()
                }
              }
            },
            [
              _c("v-icon", {
                attrs: { name: "buttons/chevrons_left", size: 13 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy
            ? _c(
                "h4",
                {
                  staticClass: "m-0 mr-auto",
                  attrs: { id: "task-ellipsis-loading" }
                },
                [_vm._v("Загрузка заявки на смену")]
              )
            : _c("h4", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          !_vm.isBusy
            ? _c(
                "span",
                {
                  class: [
                    "custom-tag ml-auto mr-3",
                    _vm.getStatusStyle(_vm.newItem.status_id)
                  ]
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        "Статус: " + _vm.getStatusName(_vm.newItem.status_id)
                      ) +
                      "\n      "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "custom-btn-primary",
              attrs: {
                id: "save-button",
                disabled: _vm.isDisabled || _vm.loading
              },
              on: {
                click: function($event) {
                  return _vm.handleSubmit()
                }
              }
            },
            [
              _vm.loading
                ? _c("b-spinner", { attrs: { small: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("v-icon", {
                staticClass: "ml-1",
                attrs: { name: "buttons/check", size: 13 }
              }),
              _vm._v("\n        Сохранить\n      ")
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasAnyMismatch
            ? _c(
                "b-tooltip",
                {
                  key: "save-total-" + _vm.hasAnyMismatch,
                  staticClass: "tag-warning",
                  attrs: { target: "save-button" }
                },
                [
                  _vm._v(
                    "\n        Внимание: итого некоторых исполнителей не совпадает с суммой их услуг.\n      "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-body", staticStyle: { "overflow-y": "auto" } },
      [
        _c("b-skeleton-wrapper", {
          attrs: { loading: _vm.isBusy },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-tabs",
                            { staticClass: "custom-tabs", attrs: { card: "" } },
                            [
                              _c("b-tab", {
                                attrs: { disabled: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "buttons/user_file",
                                            size: 13
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v("Основная информация")
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("b-tab", {
                                attrs: { disabled: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "buttons/payment",
                                            size: 13
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Расходы")])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("b-tab", {
                                attrs: { disabled: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "buttons/file",
                                            size: 13
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Документы")])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "custom-card m-3 px-1 pt-2" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-1",
                                        attrs: { width: "17%", height: "20%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "43%"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c("b-skeleton", {
                                        attrs: { width: "13%", height: "20%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "43%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        attrs: { width: "24%", height: "20%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "25%"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        attrs: { width: "29%", height: "20%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "25%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "custom-card mb-2" },
                            [
                              _c(
                                "b-row",
                                { staticClass: "pt-1" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "60%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "44%"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "66%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "44%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "75%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "44%"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "82%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "44%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "mt-1 mb-4" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "42%",
                                          height: "78%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "custom-card mb-2" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "20%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "43%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "mb-2" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "42%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "45%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "pb-4" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("b-skeleton", {
                                        staticClass: "mb-2",
                                        attrs: { width: "14%", height: "24%" }
                                      }),
                                      _vm._v(" "),
                                      _c("b-skeleton", {
                                        attrs: {
                                          type: "input",
                                          width: "100%",
                                          height: "77%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-card",
                            { staticClass: "custom-card" },
                            [
                              _c("b-skeleton", {
                                staticClass: "pt-3",
                                attrs: { width: "13%", height: "50%" }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                { attrs: { flush: "", "bg-variant": "light" } },
                                _vm._l(11, function(i) {
                                  return _c(
                                    "b-list-group-item",
                                    {
                                      key: "skeleton-item-" + i,
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c("b-skeleton", {
                                            staticClass: "mb-0",
                                            attrs: {
                                              width: _vm.getLeftSkeletonWidth(
                                                i
                                              ),
                                              height: "20%"
                                            }
                                          }),
                                          _vm._v(" "),
                                          i === 7 || i === 9 || i === 11
                                            ? _c(
                                                "span",
                                                [
                                                  _c("b-skeleton", {
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      type: "text",
                                                      width: "45%"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("b-skeleton", {
                                            staticClass: "mr-5",
                                            attrs: {
                                              width: _vm.getRightSkeletonWidth(
                                                i
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-body" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { "align-v": "center", cols: "auto" } },
                            [
                              _c("h5", { staticClass: "text-muted" }, [
                                _vm._v("Исполнители")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mr-auto", attrs: { cols: "auto" } },
                            [
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "520%",
                                  height: "68%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "260%",
                                  height: "68%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "ml-5", attrs: { cols: "auto" } },
                            [
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "110%",
                                  height: "68%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mr-5", attrs: { cols: "auto" } },
                            [
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "250%",
                                  height: "68%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-center text-muted d-flex align-items-center justify-content-center"
                        },
                        [
                          _c("div", { staticClass: "spinner" }, [
                            _c("div", { staticClass: "rect1" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "rect2" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "rect3" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "rect4" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "rect5" })
                          ]),
                          _vm._v(" "),
                          _c("h5", [_vm._v("Загрузка исполнителей")])
                        ]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isBusy,
                expression: "!isBusy"
              }
            ]
          },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "b-tabs",
                      { staticClass: "custom-tabs", attrs: { card: "" } },
                      [
                        _c(
                          "b-tab",
                          {
                            attrs: { active: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function() {
                                  return [
                                    _c("v-icon", {
                                      staticClass: "mr-2",
                                      attrs: {
                                        name: "buttons/user_file",
                                        size: 13
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Основная информация")])
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "b-card",
                              { staticClass: "custom-card mb-2" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            staticClass: "mb-0",
                                            attrs: {
                                              id: "group-location",
                                              label: "Объект"
                                            }
                                          },
                                          [
                                            _c("location-select", {
                                              ref: "location_select",
                                              attrs: {
                                                id: "input-location-select",
                                                value: _vm.newItem.location_id,
                                                "is-disabled": _vm.isDisabled,
                                                state: _vm.getFieldState(
                                                  "location_id"
                                                )
                                              },
                                              on: {
                                                onSelect: _vm.onLocationChange
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            staticClass: "mb-0",
                                            attrs: {
                                              id: "group-start-address",
                                              label: _vm.$t(
                                                "message.tasks.modal.start_address"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input_start_address",
                                                size: "sm",
                                                type: "text",
                                                disabled: _vm.isDisabled,
                                                state: _vm.getFieldState(
                                                  "start_address"
                                                ),
                                                placeholder: _vm.$t(
                                                  "message.tasks.modal.start_addressPlaceholder"
                                                )
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.start_address,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "start_address",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newItem.start_address"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-executor",
                                              label: "Менеджер"
                                            }
                                          },
                                          [
                                            _c("user-select", {
                                              ref: "user_select",
                                              staticClass: "mr-2 flex-fill",
                                              attrs: {
                                                id: "input-user-select",
                                                state: _vm.getFieldState(
                                                  "executor"
                                                ),
                                                value: _vm.newItem.executor,
                                                "is-disabled":
                                                  _vm.isDisabled ||
                                                  _vm.newItem.location_id ===
                                                    0 ||
                                                  _vm.userSelectIsBusy
                                              },
                                              on: {
                                                onSelect: _vm.onSelectExecutor
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-project",
                                              label: "Руководитель"
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input-project",
                                                readonly: "",
                                                value:
                                                  _vm.newItem.project_name ||
                                                  "-"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-task-group",
                                              label: "Группа"
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                readonly: "",
                                                value:
                                                  _vm.newItem.group_name || "-"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-card",
                              { staticClass: "custom-card mb-2" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-startDate",
                                              label: _vm.$t(
                                                "message.tasks.modal.start_date"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input_startDate",
                                                size: "sm",
                                                type: "date",
                                                disabled: _vm.isDisabled,
                                                placeholder: _vm.$t(
                                                  "message.tasks.modal.start_datePlaceholder"
                                                )
                                              },
                                              model: {
                                                value: _vm.startDate,
                                                callback: function($$v) {
                                                  _vm.startDate = $$v
                                                },
                                                expression: "startDate"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-startTime",
                                              label: _vm.$t(
                                                "message.tasks.modal.start_time"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input_startTime",
                                                size: "sm",
                                                type: "time",
                                                disabled: _vm.isDisabled
                                              },
                                              model: {
                                                value: _vm.startTime,
                                                callback: function($$v) {
                                                  _vm.startTime = $$v
                                                },
                                                expression: "startTime"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-endDate",
                                              label: _vm.$t(
                                                "message.tasks.modal.end_date"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input-endDate",
                                                size: "sm",
                                                type: "date",
                                                disabled: _vm.isDisabled
                                              },
                                              model: {
                                                value: _vm.endDate,
                                                callback: function($$v) {
                                                  _vm.endDate = $$v
                                                },
                                                expression: "endDate"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-endTime",
                                              label: _vm.$t(
                                                "message.tasks.modal.end_time"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input-endTime",
                                                size: "sm",
                                                type: "time",
                                                disabled: _vm.isDisabled
                                              },
                                              model: {
                                                value: _vm.endTime,
                                                callback: function($$v) {
                                                  _vm.endTime = $$v
                                                },
                                                expression: "endTime"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "custom-btn-primary",
                                    attrs: { disabled: _vm.isDisabled },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.setWorkersDateTapped()
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", {
                                      staticClass: "ml-1",
                                      attrs: {
                                        name: "buttons/card_check",
                                        size: 15
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          "Установить дату и время исполнителям"
                                        ) +
                                        "\n                "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-card",
                              { staticClass: "custom-card" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-work-type",
                                              label: "Вид работ объекта"
                                            }
                                          },
                                          [
                                            _c("location-works-select", {
                                              ref: "location_works_select",
                                              attrs: {
                                                id: "location-works-select",
                                                "is-disabled": _vm.isDisabled,
                                                state: _vm.getFieldState(
                                                  "task_location_works"
                                                )
                                              },
                                              on: {
                                                onSelect:
                                                  _vm.onLocationWorkSelect
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-workers-count",
                                              label:
                                                "Планируемое количество исполнителей"
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input-workers-count",
                                                size: "sm",
                                                type: "number",
                                                min: "0",
                                                disabled: _vm.isPlanWorkersCountDisabled(),
                                                state: _vm.getFieldState(
                                                  "plan_workers_count"
                                                )
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem
                                                    .plan_workers_count,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "plan_workers_count",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "newItem.plan_workers_count"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "group-cargo-description",
                                      label: "Примечание"
                                    }
                                  },
                                  [
                                    _c("b-form-textarea", {
                                      attrs: {
                                        id: "textarea-cargo-description",
                                        size: "sm",
                                        disabled: _vm.isDisabled,
                                        rows: 2,
                                        "max-rows": 2,
                                        "no-resize": ""
                                      },
                                      model: {
                                        value: _vm.newItem.cargo_description,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newItem,
                                            "cargo_description",
                                            $$v
                                          )
                                        },
                                        expression: "newItem.cargo_description"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          {
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function() {
                                  return [
                                    _c("v-icon", {
                                      staticClass: "mr-2",
                                      attrs: {
                                        name: "buttons/payment",
                                        size: 13
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Расходы")])
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "b-card",
                              { staticClass: "custom-card" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group_additional_cost",
                                              label: _vm.$t(
                                                "message.tasks.modal.additional_cost"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input_additional_cost",
                                                size: "sm",
                                                type: "number",
                                                disabled: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.additional_cost,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "additional_cost",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "newItem.additional_cost"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group_additional_income",
                                              label: _vm.$t(
                                                "message.tasks.modal.additional_income"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input_additional_income",
                                                size: "sm",
                                                type: "number",
                                                disabled: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.additional_income,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "additional_income",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "newItem.additional_income"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group_declarated_cost",
                                              label: _vm.$t(
                                                "message.tasks.modal.declarated_cost"
                                              )
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "input_declarated_cost",
                                                size: "sm",
                                                type: "number",
                                                disabled: _vm.isDisabled
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.declarated_cost,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "declarated_cost",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "newItem.declarated_cost"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "group_description",
                                      label: _vm.$t(
                                        "message.tasks.modal.description"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-textarea", {
                                      attrs: {
                                        id: "textarea_description",
                                        size: "sm",
                                        disabled: _vm.isDisabled,
                                        placeholder: _vm.$t(
                                          "message.tasks.modal.descriptionPlaceholder"
                                        ),
                                        rows: 2,
                                        "max-rows": 2,
                                        "no-resize": ""
                                      },
                                      model: {
                                        value: _vm.newItem.description,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newItem,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "newItem.description"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          {
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function() {
                                  return [
                                    _c("v-icon", {
                                      staticClass: "mr-2",
                                      attrs: { name: "buttons/file", size: 13 }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Документы")])
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _vm._v(" "),
                            _c("task-files", {
                              ref: "task_files",
                              attrs: { "is-disabled": _vm.isDisabled }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "b-card",
                      { staticClass: "custom-card" },
                      [
                        _c("h5", { attrs: { id: "task-header" } }, [
                          _vm._v("Итоговые расчёты")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-list-group",
                          { attrs: { flush: "", "bg-variant": "light" } },
                          [
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n                Заказчик\n                "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.customer.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n                Объект\n                "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.location.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n                Стоимость за единицу\n                "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.newItem.payment_first))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.getTotalTitle()) +
                                    "\n                "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(_vm.newItem.total_hours)
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n                Сумма с заказчика\n                "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(_vm.newItem.total_price)
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n                Исполнителям\n                "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(
                                        _vm.newItem.total_worker_price
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    "\n                  Исполнителям\n                  "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-small text-secondary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    с учетом коммиссии сервиса "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.newItem.smz_cost) + "%"
                                        )
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(
                                        _vm.newItem
                                          .total_worker_price_with_comiss
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("message.tasks.modal.total_delta")
                                    ) +
                                    "\n                "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(_vm.newItem.total_delta)
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    "\n                  Маржинальность\n                  "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-small text-secondary"
                                    },
                                    [_vm._v("без учета расходов за месяц")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.marginality) + " %")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n                Менеджеру\n                "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(_vm.newItem.total_manager)
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.visibleProject()
                              ? _c(
                                  "b-list-group-item",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between align-items-center"
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "\n                  Руководителю\n                  "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-small text-secondary"
                                        },
                                        [_vm._v("без учета расходов за месяц")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.newItem.project_id != null
                                            ? _vm.priceFormat(
                                                _vm.newItem.total_project
                                              )
                                            : "-"
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "header",
              { staticClass: "page-header" },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center w-100" },
                  [
                    _c("h5", { staticClass: "mb-0" }, [_vm._v("Исполнители")]),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        ref: "allWorkerPriceButton",
                        staticClass: "custom-btn-secondary ml-3 mr-auto",
                        attrs: { id: "allWorkerPriceButton" }
                      },
                      [_vm._v("\n            Назначить\n          ")]
                    ),
                    _vm._v(" "),
                    _vm.newItem.id && !_vm.$route.meta.isCopy
                      ? _c(
                          "b-button",
                          {
                            staticClass: "custom-btn-secondary mr-1",
                            attrs: { disabled: _vm.responseLoading },
                            on: { click: _vm.refreshBalansResponses }
                          },
                          [_vm._v("\n            Обновить отклики\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("export-sidebar", {
                      staticClass: "mr-1",
                      attrs: {
                        "sidebar-id": "sidebar-task-workers-export",
                        "storage-key": "sidebar_task_workers_export",
                        columns: _vm.exportableFields,
                        "data-to-export": _vm.dataToExport,
                        "data-mapper": _vm.mapTaskForExport,
                        "file-name": "TaskWorkers.xlsx",
                        "sheet-name": "TaskWorkers",
                        "is-busy": _vm.isBusy,
                        "items-count": _vm.totalTWRows
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle.sidebar-fields",
                            modifiers: { "sidebar-fields": true }
                          }
                        ],
                        staticClass: "custom-btn-secondary mr-1",
                        attrs: { id: "table-settings" },
                        on: { click: _vm.onPopoverClose }
                      },
                      [
                        _c("v-icon", {
                          attrs: { name: "buttons/cog", size: 13 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          target: "table-settings",
                          triggers: "hover",
                          "custom-class": "custom-tooltip",
                          noninteractive: ""
                        }
                      },
                      [_vm._v("\n            Колонки\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "custom-btn-primary",
                        attrs: { disabled: _vm.isDisabled },
                        on: { click: _vm.showFreeWorkers }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "ml-1",
                          attrs: { name: "buttons/plus", size: 12 }
                        }),
                        _vm._v("\n            Добавить исполнителя\n          ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-popover",
                  {
                    ref: "popover",
                    attrs: {
                      target: "allWorkerPriceButton",
                      triggers: "click",
                      show: _vm.popoverShow,
                      placement: "auto",
                      container: "my-container"
                    },
                    on: {
                      "update:show": function($event) {
                        _vm.popoverShow = $event
                      },
                      show: _vm.onShow,
                      shown: _vm.onShown,
                      hidden: _vm.onHidden
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center w-100"
                              },
                              [
                                _c(
                                  "small",
                                  {
                                    staticClass: "font-weight-bold text-muted"
                                  },
                                  [_vm._v("Назначить исполнителям")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "close pb-1",
                                    attrs: { "aria-label": "Close" },
                                    on: { click: _vm.onPopoverClose }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("×")]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-1",
                            attrs: {
                              label: "Ставка",
                              "label-for": "allWorkerPriceInput",
                              "label-cols": "3"
                            }
                          },
                          [
                            _c("b-form-input", {
                              ref: "allWorkerPriceInput",
                              attrs: {
                                id: "allWorkerPriceInput",
                                type: "number",
                                placeholder: "Введите ставку",
                                size: "sm"
                              },
                              model: {
                                value: _vm.allWorkerPriceModel,
                                callback: function($$v) {
                                  _vm.allWorkerPriceModel = _vm._n($$v)
                                },
                                expression: "allWorkerPriceModel"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          { attrs: { label: "Обед", "label-cols": "3" } },
                          [
                            _c("b-form-input", {
                              ref: "allWorkerDinnerInput",
                              attrs: {
                                type: "number",
                                placeholder: "Введите обед",
                                size: "sm"
                              },
                              model: {
                                value: _vm.allWorkerDinnerModel,
                                callback: function($$v) {
                                  _vm.allWorkerDinnerModel = _vm._n($$v)
                                },
                                expression: "allWorkerDinnerModel"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          { attrs: { label: "Услуги СМЗ", "label-cols": "3" } },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "auto" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-1",
                                        attrs: { label: "Услуга" }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.locationWorkServices,
                                            size: "sm"
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "first",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    {
                                                      attrs: {
                                                        value: null,
                                                        disabled: ""
                                                      }
                                                    },
                                                    [_vm._v("Выберите услугу")]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ]),
                                          model: {
                                            value:
                                              _vm.allSmzWorkerServiceSelected,
                                            callback: function($$v) {
                                              _vm.allSmzWorkerServiceSelected = $$v
                                            },
                                            expression:
                                              "allSmzWorkerServiceSelected"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-0",
                                        attrs: { label: "Количество" }
                                      },
                                      [
                                        _c("b-form-input", {
                                          ref:
                                            "allSmzWorkerServiceQuantityInput",
                                          attrs: {
                                            type: "number",
                                            placeholder: "Введите количество",
                                            size: "sm"
                                          },
                                          model: {
                                            value:
                                              _vm.allSmzWorkerServiceQuantity,
                                            callback: function($$v) {
                                              _vm.allSmzWorkerServiceQuantity = _vm._n(
                                                $$v
                                              )
                                            },
                                            expression:
                                              "allSmzWorkerServiceQuantity"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end mt-1" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "custom-btn-secondary",
                                on: { click: _vm.onPopoverClose }
                              },
                              [_vm._v("Закрыть")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "custom-btn-primary ml-1",
                                on: { click: _vm.onPopoverOk }
                              },
                              [_vm._v("Назначить")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-body" },
              [
                _vm.isBusy ||
                (_vm.newItem.task_workers &&
                  _vm.newItem.task_workers.length > 0)
                  ? [
                      _c(
                        "div",
                        { staticClass: "page-table-container" },
                        [
                          _c("b-table", {
                            ref: "TaskWorkers",
                            staticClass: "mb-0 text-small custom-table",
                            attrs: {
                              id: "task-workers",
                              "tbody-tr-class": _vm.tbodyRowClass,
                              "select-mode": "multi",
                              responsive: "",
                              items: _vm.newItem.task_workers,
                              fields: _vm.renderedFields,
                              "current-page": _vm.currentPage,
                              "per-page": _vm.perPage,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDesc
                            },
                            on: {
                              "update:sortBy": function($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function($event) {
                                _vm.sortDesc = $event
                              },
                              "update:sort-desc": function($event) {
                                _vm.sortDesc = $event
                              },
                              "row-dblclicked": _vm.onRowDblClicked,
                              "row-clicked": _vm.onRowClicked
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head(selected)",
                                  fn: function(row) {
                                    return [
                                      _c("b-form-checkbox", {
                                        staticClass: "mx-1",
                                        attrs: {
                                          indeterminate: _vm.indeterminate,
                                          size: "md"
                                        },
                                        on: { change: _vm.selectPageRows },
                                        model: {
                                          value: _vm.allSelected,
                                          callback: function($$v) {
                                            _vm.allSelected = $$v
                                          },
                                          expression: "allSelected"
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(selected)",
                                  fn: function(row) {
                                    return [
                                      _c("b-form-checkbox", {
                                        staticClass: "mx-1",
                                        attrs: {
                                          size: "md",
                                          checked: row.item.selected
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(risk)",
                                  fn: function(row) {
                                    return [
                                      _c("worker-risk", {
                                        attrs: {
                                          "employment-type":
                                            row.item.worker &&
                                            row.item.worker.employment_type,
                                          risk:
                                            _vm.workerRisks[row.item.worker_id]
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(name)",
                                  fn: function(row) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(row.item.name) +
                                          "\n                "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      row.item.inn != null
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "m-0 p-0 text-secondary text-small"
                                            },
                                            [
                                              _vm._v(
                                                "ИНН: " + _vm._s(row.item.inn)
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "m-0 p-0 text-small",
                                          attrs: {
                                            href: _vm.telUrl(row.item.phone)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.phoneString(row.item.phone)
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(price)",
                                  fn: function(row) {
                                    return [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input_price1",
                                          type: "number",
                                          min: 0,
                                          disabled: _vm.isDisabled,
                                          size: "sm",
                                          autocomplete: "off"
                                        },
                                        on: { keydown: _vm.preventMinus },
                                        model: {
                                          value: row.item.price,
                                          callback: function($$v) {
                                            _vm.$set(
                                              row.item,
                                              "price",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "row.item.price"
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(start_date)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "b-form",
                                        { attrs: { inline: "" } },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              id: "input_startDate1",
                                              type: "date",
                                              disabled: _vm.isDisabled,
                                              size: "sm"
                                            },
                                            model: {
                                              value: row.item.string_start_date,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "string_start_date",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.item.string_start_date"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input_startTime1",
                                              type: "time",
                                              disabled: _vm.isDisabled,
                                              size: "sm"
                                            },
                                            model: {
                                              value: row.item.start_time,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "start_time",
                                                  $$v
                                                )
                                              },
                                              expression: "row.item.start_time"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(end_date)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "b-form",
                                        { attrs: { inline: "" } },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              id: "input_endDate1",
                                              type: "date",
                                              disabled: _vm.isDisabled,
                                              size: "sm"
                                            },
                                            model: {
                                              value: row.item.string_end_date,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "string_end_date",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.item.string_end_date"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input_endTime1",
                                              type: "time",
                                              disabled: _vm.isDisabled,
                                              size: "sm"
                                            },
                                            model: {
                                              value: row.item.end_time,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "end_time",
                                                  $$v
                                                )
                                              },
                                              expression: "row.item.end_time"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(road_price)",
                                  fn: function(row) {
                                    return [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input_price",
                                          type: "number",
                                          disabled: _vm.isDisabled,
                                          size: "sm",
                                          autocomplete: "off"
                                        },
                                        model: {
                                          value: row.item.road_price,
                                          callback: function($$v) {
                                            _vm.$set(
                                              row.item,
                                              "road_price",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "row.item.road_price"
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(dinner)",
                                  fn: function(row) {
                                    return [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input_dinner",
                                          type: "number",
                                          disabled: _vm.isDisabled,
                                          step: "0.5",
                                          size: "sm",
                                          autocomplete: "off"
                                        },
                                        model: {
                                          value: row.item.dinner,
                                          callback: function($$v) {
                                            _vm.$set(
                                              row.item,
                                              "dinner",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "row.item.dinner"
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(prepaid)",
                                  fn: function(row) {
                                    return [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input_prepaid",
                                          type: "number",
                                          disabled: _vm.isDisabled,
                                          size: "sm",
                                          autocomplete: "off"
                                        },
                                        model: {
                                          value: row.item.prepaid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              row.item,
                                              "prepaid",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "row.item.prepaid"
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(total_units)",
                                  fn: function(row) {
                                    return [
                                      _vm.newItem.unit_code === "539"
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(row.item.total_units) +
                                                "\n                "
                                            )
                                          ])
                                        : _c(
                                            "div",
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input_total_units",
                                                  type: "number",
                                                  disabled: _vm.isDisabled,
                                                  size: "sm",
                                                  autocomplete: "off"
                                                },
                                                model: {
                                                  value: row.item.total_units,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      row.item,
                                                      "total_units",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "row.item.total_units"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(total_price)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip",
                                              value: {
                                                title: _vm.mismatchingTotals.includes(
                                                  row.item.worker_id
                                                )
                                                  ? _vm.getTooltipTitle(
                                                      row.item
                                                    )
                                                  : "",
                                                variant: "danger",
                                                placement: "auto",
                                                triggers: "hover"
                                              },
                                              expression:
                                                "{\n                  title: mismatchingTotals.includes(row.item.worker_id) ? getTooltipTitle(row.item) : '',\n                  variant: 'danger',\n                  placement: 'auto',\n                  triggers: 'hover'\n                  }"
                                            }
                                          ],
                                          class: {
                                            "text-danger font-weight-bold": _vm.mismatchingTotals.includes(
                                              row.item.worker_id
                                            )
                                          },
                                          attrs: {
                                            id:
                                              "total-price-" +
                                              row.item.worker_id
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.priceFormat(
                                                  row.item.total_price
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(description)",
                                  fn: function(row) {
                                    return [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          id: "textarea_descriptionq",
                                          disabled: _vm.isDisabled,
                                          placeholder: _vm.$t(
                                            "message.tasks.modal.descriptionPlaceholder"
                                          ),
                                          rows: 2,
                                          "max-rows": 2,
                                          size: "sm"
                                        },
                                        model: {
                                          value: row.item.description,
                                          callback: function($$v) {
                                            _vm.$set(
                                              row.item,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "row.item.description"
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(balans_pro_response_status)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class: _vm.isSelfEmployed(row.item)
                                            ? [
                                                "custom-tag",
                                                !_vm.balansPaymentBlockReason(
                                                  row.item
                                                )
                                                  ? "tag-success"
                                                  : "tag-warning"
                                              ]
                                            : "",
                                          attrs: {
                                            title: _vm.balansPaymentBlockReason(
                                              row.item
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.balansResponseLabel(row.item)
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(paid)",
                                  fn: function(row) {
                                    return [
                                      _vm.visibleAdmins()
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "button",
                                                {
                                                  class: [
                                                    "custom-tag",
                                                    _vm.getPaidStyle(row)
                                                  ],
                                                  attrs: {
                                                    type: "button",
                                                    disabled:
                                                      _vm.isDisabled ||
                                                      _vm.newItem.status_id ===
                                                        1 ||
                                                      (!row.item.paid &&
                                                        !!_vm.balansPaymentBlockReason(
                                                          row.item
                                                        ))
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showModalAccept(
                                                        row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.getPaidTitle(row)
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !row.item.paid &&
                                              _vm.balansPaymentBlockReason(
                                                row.item
                                              )
                                                ? _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "d-block text-muted mt-1"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.balansPaymentBlockReason(
                                                              row.item
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              row.item.paid &&
                                              row.item.has_integration_details
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "info",
                                                        disabled: _vm.isDisabled
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onPaidDetails(
                                                            row
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: { icon: "info" }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getPaidTitle(row)
                                                  ) +
                                                  "\n                  "
                                              ),
                                              row.item.paid
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "info",
                                                        disabled: _vm.isDisabled
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onPaidDetails(
                                                            row
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: { icon: "info" }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(action)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                          staticStyle: { gap: "8px" }
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              class: row.detailsShowing
                                                ? "custom-btn-secondary"
                                                : "custom-btn-primary",
                                              attrs: { id: "tws-details" },
                                              on: {
                                                click: function($event) {
                                                  return row.toggleDetails()
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  name: "buttons/page_list",
                                                  size: 14
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "custom-btn-danger",
                                              attrs: {
                                                disabled: _vm.isDisabled
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onRemove(row)
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  name: "buttons/trash",
                                                  size: 14
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "row-details",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "m-0 p-2",
                                          attrs: { "no-body": "" }
                                        },
                                        [
                                          _c("task-worker-services", {
                                            ref: "task_worker_services",
                                            attrs: {
                                              tws:
                                                row.item.task_worker_services,
                                              tw: row.item,
                                              "tws-options":
                                                _vm.locationWorkServices,
                                              "block-reason": _vm.workerServiceBlockReason(
                                                row.item.worker,
                                                row.item.worker_id
                                              ),
                                              disabled: _vm.isDisabled
                                            },
                                            on: {
                                              change: function($event) {
                                                row.item.task_worker_services = $event
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3534877060
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "page-pagination" },
                        [
                          _c("pagination-footer", {
                            attrs: {
                              "total-rows": _vm.totalTWRows,
                              "per-page": _vm.perPage,
                              "current-page": _vm.currentPage
                            },
                            on: {
                              "update:currentPage": function($event) {
                                _vm.currentPage = $event
                              },
                              "update:current-page": function($event) {
                                _vm.currentPage = $event
                              },
                              "per-page-change": _vm.onPerPageChange
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _c(
                      "div",
                      { staticClass: "empty-state-container" },
                      [
                        _c("v-icon", {
                          attrs: { name: "navbar/empty_table", size: 90 }
                        }),
                        _vm._v(" "),
                        _c("h5", [_vm._v("Нет добавленных исполнителей")])
                      ],
                      1
                    )
              ],
              2
            ),
            _vm._v(" "),
            _c("workers-free", {
              ref: "free_workers_table",
              attrs: {
                workers: _vm.newItem.task_workers,
                "location-id": _vm.newItem.location_id
              },
              on: { addToTask: _vm.addToTask }
            }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "modalAccept",
                attrs: {
                  id: "modal-accept",
                  title: _vm.$t("message.tasks.modal.acceptWorkerTitle"),
                  "ok-title": _vm.$t("message.actions.ok"),
                  "cancel-title": _vm.$t("message.actions.cancel"),
                  centered: ""
                },
                on: {
                  ok: function($event) {
                    return _vm.acceptItem()
                  }
                }
              },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("message.tasks.modal.acceptWorkerDesc")) +
                      ' "' +
                      _vm._s(_vm.acceptWorker.name) +
                      '"'
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "modalTWDetails",
                attrs: {
                  id: "modal-tw-details",
                  title: "Детали оплаты",
                  "ok-only": "",
                  size: "lg"
                }
              },
              [
                _vm.twDetails != null
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-list-group",
                          { attrs: { flush: "", "bg-variant": "light" } },
                          [
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n              Задание\n              "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(this.twDetails.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n              Описание\n              "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(this.twDetails.description))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n              Стоимость\n              "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(this.twDetails.price)
                                    ) + " ₽"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n              Статус\n              "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(this.twDetails.status))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n              Дата создания\n              "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(this.twDetails.created_at))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v(
                                  "\n              Договор\n              "
                                ),
                                _c(
                                  "b-link",
                                  {
                                    attrs: {
                                      href: this.twDetails.contract.url,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(this.twDetails.contract.name))]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v("\n              Акт\n              "),
                                _c(
                                  "b-link",
                                  {
                                    attrs: {
                                      href: this.twDetails.act.url,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(this.twDetails.act.name))]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                                attrs: { "bg-variant": "light" }
                              },
                              [
                                _vm._v("\n              Чек\n              "),
                                _c(
                                  "b-link",
                                  {
                                    attrs: {
                                      href: this.twDetails.act.receipt.link,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Открыть")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n              Статус оплаты\n              "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(this.twDetails.act.status_pay))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n              Оплачено исполнителю\n              "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(this.twDetails.act.sum)
                                    ) + " ₽"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n              Удержанный налог\n              "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(this.twDetails.act.tax)
                                    ) + " ₽"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n              Комиссия сервиса\n              "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(
                                        this.twDetails.act.commission
                                      )
                                    ) + " ₽"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-list-group-item",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _vm._v(
                                  "\n              Дата оплаты\n              "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatTableDateTime(
                                        new Date(
                                          this.twDetails.act.receipt.created_time
                                        )
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("dynamic-tables", {
          attrs: {
            "storage-key": "taskWorkers_columns",
            "sidebar-fields": "sidebar-fields",
            "fields-model": _vm.fieldsTW,
            fieldKey: "name"
          },
          on: {
            "update:fieldsModel": function($event) {
              _vm.fieldsTW = $event
            },
            "update:fields-model": function($event) {
              _vm.fieldsTW = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02ab2294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ab2294","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/Task.vue
// module id = null
// module chunks = 